module.exports = __webpack_public_path__ + "static/media/CT_2019_30446_1005.9b59683f.png";